import { RG_TYPE as e } from "@project-rouge/rg-core";
const a = (t) => {
  if (t.type !== e.Core)
    return !1;
  const r = t.data.hasFireLift, i = t.data.hasNonFireLift;
  return r !== void 0 && r === !0 || i !== void 0 && i === !0;
};
export {
  a as isLiftCore
};
//# sourceMappingURL=index5.js.map
